import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import Lottie from "lottie-react";
import animationData from "../../assets/images/Coming-Soon.json";

import {
  Card,
  CardHeader,
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
  Typography,
  CardBody,
  Select,
  Option,
} from "@material-tailwind/react";
import { getPieChartData } from "../../helperFunctions/apiFunction";
import { useAuthUserToken } from "../../hooks/useAuthUserToken";
import SkeletonGrid from "../../components/Loaders/SkeletonGrid";

export default function RiskManagement() {
  const { refreshToken } = useAuthUserToken();
  const [selectedOptionData, setSelectedOptionData] = useState("pcidssv4data");
  const [chartData, setChartData] = useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const [tableHead, setTableHead] = useState([]);

  const [activeTab, setActiveTab] = useState("summary");
  const data = [
    {
      label: "Summary",
      value: "summary",
    },
    {
      label: "Estimate",
      value: "estimate",
    },
  ];

  useEffect(() => {
    setIsLoading(true);
    if (activeTab === "summary") {
      getPieChartData(refreshToken, selectedOptionData)
        .then((data) => {
          if (Array.isArray(data)) {
            setChartData(data);
            setIsLoading(false);
          } else {
            console.error("Fetched data is not an array:", data);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setIsLoading(false);
        });
    } else if (activeTab === "estimate") {
      setTableHead(["Control Id", "Control Description", "Evidence Type"]);
    }
  }, [activeTab, selectedOptionData]);

  return (
    <div className="app-main__inner !pl-20">
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between md:gap-8">
            <div>
              <Typography variant="h5" color="blue-gray">
                Risk Management
              </Typography>
              <Typography color="gray" className="mt-1 font-normal">
                View compliance risks against compliance requirements
              </Typography>
            </div>
          </div>
          <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
              <Select
                color="green"
                label="Select Standard"
                value={selectedOptionData}
                onChange={(event) => {
                  setSelectedOptionData(event);
                }}
              >
                <Option value="pcidssv4data">PCI DSS 4</Option>
                <Option value="pcidssv321data">PCI DSS 3.2.1</Option>
              </Select>
            </div>
          </div>
        </CardHeader>
        <Tabs id="custom-animation" value={activeTab}>
          <TabsHeader className="mx-4 mt-4">
            {data.map(({ label, value }) => (
              <Tab
                key={value}
                value={value}
                onClick={() => setActiveTab(value)}
                className={activeTab === value ? "text-gray-900" : ""}
              >
                {label}
              </Tab>
            ))}
          </TabsHeader>
          <TabsBody
            animate={{
              initial: { y: 250 },
              mount: { y: 0 },
              unmount: { y: 250 },
            }}
          >
            {data.map(({ value, desc }) => (
              <TabPanel key={value} value={value}>
                <CardBody className="overflow-scroll px-3 p-0">
                  <table className="mt-4 w-full text-left">
                    <tbody>
                      {activeTab === "summary" ? (
                        <>
                          {isLoading ? (
                            <SkeletonGrid />
                          ) : (
                            <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
                              {chartData
                                .slice()
                                .sort((a, b) => a._id - b._id)
                                .sort((a, b) => {
                                  const idA = isNaN(a._id)
                                    ? a._id
                                    : parseInt(a._id, 10);
                                  const idB = isNaN(b._id)
                                    ? b._id
                                    : parseInt(b._id, 10);
                                  return idA - idB;
                                })
                                .map((item, index) => {
                                  const pieData = {
                                    labels: ["Compliant", "Non-Compliant"],
                                    datasets: [
                                      {
                                        data: [
                                          item.Compliant,
                                          item.NonCompliant,
                                        ],
                                        backgroundColor: ["#004c6d", "#67d0de"],
                                      },
                                    ],
                                  };

                                  return (
                                    <div key={item._id}>
                                      <div className="bg-white rounded-xl pb-3.5">
                                        <h3 className="text-center py-3">
                                          Requirement ID {item._id}
                                        </h3>
                                        <Pie
                                          data={pieData}
                                          options={{
                                            legend: {
                                              display: false,
                                            },
                                            tooltips: {
                                              enabled: false,
                                            },
                                          }}
                                        />
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          )}
                        </>
                      ) : activeTab === "estimate" ? (
                        <>
                          <div className="flex flex-col justify-center items-center">
                            <div className="w-1/2">
                              <Lottie
                                animationData={animationData}
                                loop={true}
                              />
                            </div>
                            <Typography
                              color="gray"
                              className="mt-2 font-normal"
                            >
                              We are working on something interesting!
                            </Typography>
                          </div>
                        </>
                      ) : null}
                    </tbody>
                  </table>
                </CardBody>
              </TabPanel>
            ))}
          </TabsBody>
        </Tabs>
      </Card>
    </div>
  );
}
